export default __webpack_public_path__ + "static/media/logo_jalisco_se_defiende_claro.f8aa1b6b.png";